import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Paikan päällä',
      [RoomServiceLocationType.TableService]: 'Paikan päällä',
      both: 'Paikan päällä',
    },
    [ORDER_METHODS.PICKUP]: 'Nouto',
    [ORDER_METHODS.DELIVERY]: 'Toimitus',
  },
};
